import { testimonials } from "@/mocks/guagua";
import SectionHeading from "./SectionHeading";

function Testimonials() {
  return (
    <section id="review" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="网友热议"
          title="吃瓜群众怎么说"
          desc="来自广大瓜友的真实声音。好的网站经得起围观，也经得起口碑检验。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6 transition-all hover:-translate-y-1 hover:bg-background-50"
            >
              <div className="flex items-center gap-0.5 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`${
                      i < t.rating ? "ri-star-fill" : "ri-star-line text-foreground-300"
                    }`}
                    aria-hidden="true"
                  ></i>
                ))}
              </div>
              <blockquote className="flex-1 text-sm md:text-base leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="flex items-center gap-3 border-t border-background-200 pt-4">
                <span
                  className={`grid h-10 w-10 shrink-0 items-center justify-center rounded-full ${t.color} text-background-50`}
                >
                  <i className="ri-user-smile-fill text-lg" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;